import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React, {useCallback, useState} from 'react'
import {TicketInfo} from '../ticket/ticket-info'
import {SeatingPopoverProps} from './interfaces'
import s from './seating-popover.scss'

export const SeatingPopover = ({popoverData}: SeatingPopoverProps) => {
  const [height, setHeight] = useState(0)
  const [width, setWidth] = useState(0)

  const {boundingClientRect, containerBoundingClientRect} = popoverData
  const spaceBetweenTooltipAndSeat = 10
  const shouldOpenBottom = boundingClientRect.top - height - spaceBetweenTooltipAndSeat < 10
  const top = shouldOpenBottom
    ? boundingClientRect.bottom + spaceBetweenTooltipAndSeat - containerBoundingClientRect.top
    : boundingClientRect.top - height - spaceBetweenTooltipAndSeat - containerBoundingClientRect.top
  const left = (boundingClientRect.left + boundingClientRect.right) / 2 - containerBoundingClientRect.left - width / 2

  const setWidthAndHeight = useCallback(e => {
    setHeight(e?.clientHeight)
    setWidth(e?.offsetWidth)
  }, [])

  return (
    <div
      key={popoverData?.info?.id}
      data-hook={DH.SEATINGS_MODAL_SEAT_POPOVER}
      className={classNames(s.container, {[s.bottom]: shouldOpenBottom})}
      style={{
        opacity: height ? 1 : 0,
        top,
        left,
        maxWidth: 288,
      }}
      ref={setWidthAndHeight}
    >
      <TicketInfo place={popoverData.info} inPopover />
    </div>
  )
}
